import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import api from "../../lib/api";
import { Button } from "../ui/button";
import { Clock, WarningCircle } from "@phosphor-icons/react";

/** Striscia sopra le pagine: prova in scadenza (≤7 giorni), pagamento in ritardo o abbonamento scaduto. */
export default function AvvisoAbbonamento() {
  const [s, setS] = useState(null);
  const location = useLocation();
  useEffect(() => { api.get("/abbonamento").then((r) => setS(r.data)).catch(() => {}); }, [location.pathname]);
  if (!s || location.pathname.startsWith("/abbonamento")) return null;
  const trialBreve = s.stato === "trial" && s.giorni_rimasti <= 7;
  const critico = s.stato === "scaduto" || s.stato === "in_ritardo";
  if (!trialBreve && !critico) return null;
  const testo = s.stato === "scaduto" ? "Abbonamento scaduto: le funzioni sono bloccate finché non viene riattivato."
    : s.stato === "in_ritardo" ? "Ultimo pagamento non riuscito: aggiorna la carta per non perdere l'accesso."
    : `Prova gratuita: ${s.giorni_rimasti === 0 ? "scade oggi" : `ancora ${s.giorni_rimasti} giorn${s.giorni_rimasti === 1 ? "o" : "i"}`}.`;
  return (
    <div className={`border-b px-4 md:px-8 py-2 flex items-center gap-3 text-xs ${critico ? "bg-red-50 border-red-200 text-red-900" : "bg-amber-50 border-amber-200 text-amber-900"}`} data-testid="avviso-abbonamento" data-stato={s.stato}>
      {critico ? <WarningCircle size={16} weight="fill" className="shrink-0" /> : <Clock size={16} weight="fill" className="shrink-0" />}
      <span className="flex-1 font-medium">{testo}</span>
      <Button asChild size="sm" variant={critico ? "default" : "outline"} className="h-7 text-xs"><Link to="/abbonamento" data-testid="avviso-abbonamento-link">{s.owner ? (s.stato === "trial" ? "Attiva piano" : "Gestisci") : "Dettagli"}</Link></Button>
    </div>
  );
}
